import { create } from "zustand";
import { initialMessages } from "@/lib/data/chat";
import { searchContent, searchKeyword } from "@/lib/data/items";
import { useItemsStore } from "@/lib/stores/itemsStore";

export const useChatStore = create((set) => ({
  messages: initialMessages,
  typing: false,
  // Rediseño: el panel derecho muestra los resultados y herramientas de la última búsqueda.
  lastResults: ["c1", "e3", "e8"],
  lastTools: [
    { name: "buscar_contenido", args: 'tema:"n8n", orden:"fecha"' },
  ],

  send: (text) => {
    const trimmed = text.trim();
    if (!trimmed) return;
    set((s) => ({
      messages: [...s.messages, { id: `m-${Date.now()}`, role: "user", text: trimmed }],
      typing: true,
    }));
    setTimeout(() => {
      const items = useItemsStore.getState().items;
      const found = searchContent(items, trimmed).filter((i) => i.analyzeStatus === "enriquecido");
      const kw = searchKeyword(trimmed);
      const toolCall = `buscar_contenido(tema:"${kw}")`;
      const reply = found.length
        ? {
            id: `m-${Date.now()}-r`,
            role: "assistant",
            toolCall,
            text:
              found.length === 1
                ? "He encontrado esto en tu biblioteca:"
                : `He encontrado ${found.length} contenidos; el más relevante es este:`,
            itemRefId: found[0].id,
          }
        : {
            id: `m-${Date.now()}-r`,
            role: "assistant",
            toolCall,
            text: "No encuentro nada sobre eso en tu biblioteca. Prueba con otro tema o comparte algo nuevo y te lo dejo listo.",
          };
      set((s) => ({
        messages: [...s.messages, reply],
        typing: false,
        lastResults: found.slice(0, 5).map((i) => i.id),
        lastTools: [{ name: "buscar_contenido", args: `tema:"${kw}"` }],
      }));
    }, 1400);
  },
}));
